function estimatePipeX(item, text) {
  const transform = item.transform || [];
  const x = Number(transform[4] || 0);
  const fontSize = Math.abs(Number(transform[0] || item.height || 9)) || 9;
  const pipeIndex = text.indexOf("|");
  if (pipeIndex <= 0) return x;

  if (/^•\s*\(\|/.test(text)) return x + fontSize * 1.03;
  if (/cas:\s*\|/.test(text)) return x + fontSize * 2.1;
  if (/Resp\.\s*Pedag[oó]gico:\|/.test(text)) return x + fontSize * 8.45;
  if (/Resp\.\s*Financeiro:\s*\|/.test(text)) return x + fontSize * 8.1;

  const beforePipe = text.slice(0, pipeIndex);
  const textLength = Math.max(text.length, 1);
  return x + (Number(item.width || 0) * beforePipe.length) / textLength;
}

export function contractPipeAnchorsFromTextItems(items, pageHeight) {
  const pipes = (items || [])
    .flatMap((item) => {
      const text = String(item?.str || item?.text || "");
      if (!text.includes("|")) return [];
      const transform = item.transform || [];
      return [{
        x: estimatePipeX(item, text),
        y: Number(transform[5] || 0),
        width: Number(item.width || 0),
        height: Number(item.height || 0),
      }];
    })
    .filter((pipe) => Number.isFinite(pipe.x) && Number.isFinite(pipe.y));

  if (pipes.length < 5) return null;

  const sortedByVisualTop = [...pipes].sort((a, b) => {
    const dy = b.y - a.y;
    return Math.abs(dy) > 2 ? dy : a.x - b.x;
  });
  const authorization = sortedByVisualTop.slice(0, 3);
  const signatures = sortedByVisualTop.slice(3).sort((a, b) => a.x - b.x);

  if (authorization.length < 3 || signatures.length < 2) return null;

  const [imageYes, imageNo, restrictions] = authorization;
  const [pedagogicalSignature, financialSignature] = signatures;
  const validY = (anchor) => anchor.y > 0 && anchor.y < pageHeight;
  if (![imageYes, imageNo, restrictions, pedagogicalSignature, financialSignature].every(validY)) {
    return null;
  }

  return {
    imageYes,
    imageNo,
    restrictions,
    pedagogicalSignature,
    financialSignature,
  };
}
